import React from 'react';
import FormItemContainerControl from './FormItemContainerControl';
import FormItemTableCell from '../FormItemTableCell';



export default class FormItemTableCellControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemTableCellControl";
	}

	getProperty_Width()
	{
		return this.properties.Width;
    }
    
    getProperty_ColSpan()
    {
		let colspan = this.properties.ColSpan;
		if(!colspan)
			return 1;
		return colspan;
    }

    getProperty_RowSpan()
    {
		let rowspan = this.properties.RowSpan;
		if(!rowspan)
			return 1
        return rowspan;
    }

	getProperty_BorderLeft()
	{
		return "solid 1px #000";
    }
    
    getProperty_BorderRight()
	{
		return "solid 1px #000";
    }
    
    getProperty_BorderTop()
	{
		return "solid 1px #000";
    }
    
    getProperty_BorderBottom()
	{
		return "solid 1px #000";
	}

	getProperty_HorizontalAlignment()
	{
		return "center";
	}


	getStyle()
	{
		let style = {};
		//let length = this.parentControl.childrenControl.length;
		//style.width = 
		
		let _width = this.getProperty_Width();
        if(_width)
        {
            style.width = _width + "px";
		}
		
		let _height = this.getProperty_Height();
		if(_height)
		{
			style.height = _height + "px";
		}

		return style;
	}

	getComponentInstance(parent,forLookup)
	{
		this.component = <FormItemTableCell key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId} 
						control={this} colspan = {this.getProperty_ColSpan()} rowspan = {this.getProperty_RowSpan()}  
                        forLookup={forLookup} groupAlias={this.groupAlias} horizontalAlignment={this.getProperty_HorizontalAlignment()} 
                        customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId}
                        contextMenuData={this.contextMenuData} borderLeft={this.getProperty_BorderLeft()} borderRight={this.getProperty_BorderRight()}
						borderTop={this.getProperty_BorderTop()} borderBottom={this.getProperty_BorderBottom()}/>;
		return this.component;
	}
}



// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemTableCellControl.js